// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { informationStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import xOrderInformationStyles from "@west/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { color, mergeWithCss } from "@west/XDL/Utilities";
import { css } from "styled-components";

informationStyles.invoiceInformationGridContainer = {
    gap: 0,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 24px;
    `,
};
informationStyles.informationGridContainer = {
    gap: 0,
    css: css`
        padding-bottom: 24px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 24px;
    `,
};

informationStyles.headingAndTextStyles = {
    ...xOrderInformationStyles.headingAndTextStyles,
};

informationStyles.statusGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.invoiceDateGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.termsGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.poNumberGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.salespersonGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.shippingMethodGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.dueDateGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.vatNumberGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.billingAddressGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.shippingAddressGridItem = {
    width: [12, 12, 6, 6, 6],
};

informationStyles.billingAddressStyle = {
    titleText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
    headerText: {
        css: css`
            display: none;
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 24px;
        `,
    },
};
informationStyles.shippingAddressStyle = {
    wrapper: {
        css: css`
            margin-bottom: 24px;
        `,
    },
    titleText: {
        css: css`
            display: none;
        `,
    },
    headerText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
};
